import React from "react";
import Header from "./header/Header";
import Footer from "./Footer";

const PrivacyPolicy = () => {
    return (
        <>
            <Header/>
            <section id='privacy_policy'>
                <h2>Cookies and Files Privacy Policy</h2>
                <p>
                    At Finite Engineering, we value the privacy of our website visitors and are committed to maintaining the 
                    confidentiality and security of any personal information collected. This Cookies and Files Privacy 
                    Policy outlines our practices regarding the use of cookies and other files when you visit our website. 
                    By accessing and using our website, you consent to the use of cookies and files as described in this policy.
                </p>
                <br/><br/><br/>
                <div>
                    <ul>
                        <li>1.	Types of Cookies and Files Used: We may use different types of cookies and files, including but not limited to:</li>
                        <ol>
                            <br/>
                            <li>
                                Essential Cookies: These cookies are necessary for the proper functioning of the website and enable core features and security.
                            </li>
                            <br/>
                            <li>
                                Analytical Cookies: These cookies help us analyze website traffic and usage patterns, allowing us to improve the user experience and optimize our website's performance.
                            </li>
                            <br/>
                            <li>
                                Preference Cookies: These cookies remember your preferences and settings, providing a more personalized browsing experience.
                            </li>
                            <br/>
                            <li>
                                Third-Party Cookies: We may allow trusted third parties to place cookies on our website for advertising, analytics, and other purposes.
                            </li>
                        </ol>
                        <br/><br/>
                        <li>
                            2.	Purpose of Cookies and Files: The cookies and files used on our website serve the following purposes:
                        </li>
                        <ol>
                            <br/>
                            <li>
                                Enhance your browsing experience and provide personalized content.
                            </li>
                            <br/>
                            <li>
                                Improve website performance and functionality.
                            </li>
                            <br/>
                            <li>
                                Analyze and understand user behavior to enhance our services and offerings.
                            </li>
                            <br/>
                            <li>
                                Measure the effectiveness of our marketing campaigns.
                            </li>
                            <br/>
                            <li>
                                Ensure the security and integrity of our website.
                            </li>
                        </ol>
                        <br/><br/>
                        <li>
                            3.  Data Collection and Usage: When you visit our website, certain information may be automatically collected, such as your IP address, browser type, operating system, and referring URL. This information is used for analytical and statistical purposes and does not personally identify you. Any personal information you voluntarily provide through contact forms or other means will be treated in accordance with our Privacy Policy.
                        </li>
                        <br/><br/>
                        <li>
                            4.  Cookie Management and Opt-Out: You have the option to manage or disable cookies through your browser settings. Please note that disabling certain cookies may affect the functionality and user experience of our website. For more information on how to control cookies, please refer to your browser's documentation.
                        </li>
                        <br/><br/>
                        <li>
                            5.  Third-Party Websites: Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. We encourage you to review the privacy policies of any third-party websites you visit.
                        </li>
                        <br/><br/>
                        <li>
                            6.  Updates to the Cookies and Files Privacy Policy: We may update this Cookies and Files Privacy Policy from time to time. Any changes will be posted on this page, and the revised policy will be effective upon posting. We encourage you to review this policy periodically for any updates or changes.
                        </li>
                        <br/><br/><br/>
                    </ul>
                </div>
                <p>
                    If you have any questions or concerns regarding our Cookies and Files Privacy Policy, please contact us through the provided channels.
                </p>
            </section>
            <Footer/>
        </>
    )
}

export default PrivacyPolicy;